import { h, Component } from 'preact';
import s from 'components/templates/scrollingCarousel/scrollingCarousel.sss';
import { Link } from 'components/core/link/link';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll.js';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class ScrollingCarousel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeIndex: 0,
			isFirst: true,
			isLast: false,
			centeredTouts: true
		};

		this.handleScroll      = this.handleScroll.bind(this);
		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.setCarouselSizes  = this.setCarouselSizes.bind(this);

		this.touts    = sortObjectByOrder(this.props.data.touts);
		this.toutRefs = {};

	}

	componentDidMount() {
		this.handleScroll();
		this.setCarouselSizes();

		Store.on(actions.SET_CLIENT_SIZE, this.setCarouselSizes);
	}

	componentDidUpdate(prevProps) {
		const prevSize = prevProps.isDesktop;
		if (prevSize !== this.props.isDesktop) {
			this.setCarouselSizes();
		}
	}

	componentWillUnmount() {
		Store.off(actions.SET_CLIENT_SIZE, this.setCarouselSizes);
	}

	setCarouselSizes() {
		const firstTout = this.toutRefs?.tout0?.firstChild;
		const firstToutWidth = firstTout?.clientWidth;
		const firstToutStyle = getComputedStyle(firstTout);
		const marginLeft = ((firstToutStyle.marginLeft || '0px').match(/^\d+/)?.[0]) || 0;
		const marginRight = ((firstToutStyle.marginRight || '0px').match(/^\d+/)?.[0]) || 0;
		this.toutWidth = firstToutWidth + 2 * +marginRight;
		this.marginLeft = +marginLeft;
		this.handleScroll();
	}

	handleScroll() {
		const { activeIndex } = this.state;
		// on mobile, the margins of the first and last touts are smaller than the rest, whereas on desktop, those margins are larger than the rest
		// this means on desktop, (scrollLeft / standard toutWidth) will always be slightly larger than the index (eg. 1.03), while on mobile, it will be slightly smaller (eg. 0.97)
		const newIndex = this.props.isDesktop ? Math.floor(this.scroller.scrollLeft / this.toutWidth) : Math.ceil(this.scroller.scrollLeft / this.toutWidth);

		const carouselWidth = this.scroller.scrollWidth;

		if (carouselWidth < window.innerWidth) {
			this.setState({
				centeredTouts: true
			});
		} else {
			this.setState({
				centeredTouts: false
			});
		}
		const { scrollLeft } = this.scroller;

		const isFirst = scrollLeft <= this.marginLeft;
		const isLast = scrollLeft >= carouselWidth - window.innerWidth || carouselWidth < window.innerWidth;

		if (activeIndex !== newIndex) {
			this.setState({ activeIndex: newIndex });
		}

		this.setState({ isFirst: isFirst, isLast: isLast });
	}

	handleButtonClick(direction) {
		const newIndex = this.state.activeIndex + direction;
		smoothScrollTo(this.scroller, this.toutRefs['tout' + newIndex], 600, { direction: 'hor' });
	}

	renderTout(data, isDesktop, index){
		const { title, description, background, bgPoster, link = '', pageId = ''} = data;
		const src = background[ isDesktop ? 'desktop' : 'mobile' ];
		const isVideo = src.endsWith('.mp4');
		const isImage = src.endsWith('.jpg');
		let posterSrc;

		if (isVideo) posterSrc = bgPoster[ isDesktop ? 'desktop' : 'mobile' ] || '';

		return (
			<Link pageId={pageId} target={link ? '_blank' : '_self'} renderCustomChild>
				<li ref={ref => this.toutRefs['tout' + index] = ref}>
					<div class={s.tout}>
						{isVideo && <video
							onPlay={(e) => e.target.style.opacity = 1}
							onPause={(e) => e.target.style.opacity = 0}
							class={joinClasses(s.video, s.background)}
							src={src}
							autoplay
							muted
							loop
							showControls={true}
						/>}
						{isVideo && <div class={joinClasses(s.image, s.background)} style={{ backgroundImage: `url(${posterSrc})` }}/>}
						{isImage && <div class={joinClasses(s.image, s.background)} style={{ backgroundImage: `url(${src})` }}/>}
						{//title && <p class={s.title}>{title}</p>
						}
						{//description && <p class={s.description}>{description}</p>
						}
					</div>
				</li>
			</Link>
		);
	}

	renderControls() {
		const { isFirst, isLast } = this.state;

		return (
			<nav class={s.controls}>
				<button class={joinClasses(s.button, s.prev, isFirst && s.hide)} onClick={() => this.handleButtonClick(-1)}/>
				<button class={joinClasses(s.button, s.next, isLast && s.hide)} onClick={() => this.handleButtonClick(1)}/>
			</nav>
		);
	}

	render({ isDesktop }, { centeredTouts }) {
		return (
			<div id='scrollingCarousel' class={s.wrapper}>
				<ul class={s.container} onScroll={this.handleScroll} ref={ref => this.scroller = ref} style={{justifyContent: centeredTouts ? 'center' : 'flex-start'}}>
					{this.touts.map((tout, index) => this.renderTout(tout, isDesktop, index))}
				</ul>
				{this.renderControls()}
			</div>
		);
	}
}
